import { DatePipe } from "@angular/common";
import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Math from "exact-math";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-classroom",
  templateUrl: "./classroom.component.html",
  styleUrls: ["./classroom.component.css"],
})
export class ClassroomComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  alphaPattern = "[a-zA-Z .,]*";
  ClassRoomForm: FormGroup;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  crcreate: any;
  classroomList: any[];
  getclassroom: any;
  editclassroom: any;
  is_active = false;
  deleteclassroom: any;
  editstatus = false;
  crupdate: any;
  crstatusupdate: any;
  editid: any;
  department: any;
  editbut: boolean;
  classname: any;
  classno: any;
  depid: any;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  fileserver: Object;
  fileserve: any;
  file_server_id: any;
  total: number;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any = [];
  entryFields: boolean = false;
  createNew: boolean = true;
  backendValidationErrors: null;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      classname: [""],
      classno: [""],
    });

    this.ClassRoomForm = this.fb.group({
      id: [""],
      name: ["", [Validators.required]],
      class_room_no: ["", [Validators.required]],
      is_active: [""],
      file_server_id: ["", [Validators.required]],
    });
    this.ClassRoomForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });
    this.page = 1;
    await this.getClassRoom();
    await this.getFileserver();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.ClassRoomForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.ClassRoomForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.ClassRoomForm.reset();
    this.createNew = true;
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall) {
      await this.getClassRoom();
    }
  
    const res = await this.serverCall(this.classroomList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.ClassRoomForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async createClassRoom(form: FormGroup) {
    this.submitted = true;

    if (this.ClassRoomForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      name: form.value.name,
      class_room_no: form.value.class_room_no,
      file_server_id: form.value.file_server_id,
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",
    };
    this.crcreate = await this.globalService.create(
      "classroom/create",
      inputData
    );

    if (this.crcreate["status"] === 200) {
      Swal.fire("Success!", this.crcreate["message"], "success");
      this.pageshow = true;
      this.getClassRoom();
      this.reset();
      this.page = 1;
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if(this.crcreate["status"] === 422){
      this.backendValidationErrors = this.crcreate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  switch(e) {
    this.isactiveswitch = e;
  }

  async getFileserver() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.fileserver = await this.globalService.get(
      "fileServer/dropdown/list",
      filter
    );

    this.fileserve = this.fileserver["content"];
    this.spinner.hide();
  }

   getClassRoom() {
    this.spinner.show();
    if (this.page === 1) {
      this.classroomList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      name: this.classname ? this.classname : "",
      class_room_no: this.classno ? this.classno : "",
      file_server_id: this.file_server_id ? this.file_server_id : "",
      page_size: this.page_size,
    };

    this.globalService.get("classroom/list", filter).then((data)=>{
    this.getclassroom =  data;
    this.total_count = data["content"].count;

    if (data["content"]["rows"].length < this.page_size) {
      this.showLoadMore = true;
    }

    if (data["status"] === 200) {
      this.classroomList = data["content"]["rows"];

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
      this.spinner.hide();
    } else {
      this.showLoadMore = true;
      this.spinner.hide();
    }
  });  
}
  editClassRoom(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.editclassroom = await this.globalService.get(
          "classroom/get",
          filter
        );
        let comp_details = this.editclassroom["content"];
        if (this.editclassroom["status"] === 200) {
          this.ClassRoomForm.controls["id"].setValue(comp_details.id);
          this.ClassRoomForm.controls["name"].setValue(comp_details.name);
          this.ClassRoomForm.controls["class_room_no"].setValue(
            comp_details.class_room_no
          );
          this.ClassRoomForm.controls["file_server_id"].setValue(
            comp_details.file_server_id
          );
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }

  reset() {
    this.submitted = false;
    this.ClassRoomForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getClassRoom();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getClassRoom();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getClassRoom();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  Filter(classname, classno, file_server_id) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.classname != undefined && this.classname != "") {
      this.chiparray.push("Classname :" + " " + this.classname);
    }

    if (this.classno != undefined && this.classno != "") {
      this.chiparray.push("Classno :" + " " + this.classno);
    }
    this.classname = classname;
    this.classno = classno;
    this.file_server_id = file_server_id;
    this.pageshow = true;
    this.page = 1;
    this.getClassRoom();
    this.spinner.hide();
  }
  res() {
    this.filtervalues = false;
    this.classname = null;
    this.classno = null;
    this.file_server_id = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getClassRoom();
    this.spinner.hide();
  }

  ClassRoomStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.crstatusupdate = await this.globalService.update(
          "classroom/update/status",
          inputData
        );
        if (this.crstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.crstatusupdate["message"], "success");
          this.pageshow = true;
          this.getClassRoom();
          this.spinner.hide();
        }
        if (this.crstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getClassRoom();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getClassRoom();
      }
    });
    this.spinner.hide();
  }

  async updateClassRoom(form: FormGroup) {
    this.submitted = true;
    if (this.ClassRoomForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id ? form.value.id : this.editid,
      vendor_id: this.ls.get("vendor_id"),
      is_active: this.is_active ? this.is_active : this.editstatus,
      user_id: this.ls.get("createdBy"),
      name: form.value.name,
      class_room_no: form.value.class_room_no,
      file_server_id: form.value.file_server_id,
      server_ip: form.value.file_server_id,
    };
    this.crupdate = await this.globalService.update(
      "ClassRoom/update",
      inputData
    );

    if (this.crupdate["status"] === 200) {
      Swal.fire("Success!", this.crupdate["message"], "success");
      this.pageshow = true;
      this.getClassRoom();
      this.editbut = false;
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if(this.crupdate["status"] === 422){
      this.backendValidationErrors = this.crupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async deleteClassRoom(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.deleteclassroom = await this.globalService.delete(
          "classroom/delete",
          filter
        );
        if (this.deleteclassroom["status"] === 200) {
          this.classroomList = [];
          Swal.fire("Success!", this.deleteclassroom["message"], "success");
          this.pageshow = true;
          this.getClassRoom();
          this.spinner.hide();
        }
      }
    });
    this.spinner.hide();
  }

  formAddReset() {
    this.ClassRoomForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.ClassRoomForm.controls["id"].setValue(
      this.editclassroom["content"].id
    );
    this.ClassRoomForm.controls["name"].setValue(
      this.editclassroom["content"].name
    );
    this.ClassRoomForm.controls["class_room_no"].setValue(
      this.editclassroom["content"].class_room_no
    );
    this.ClassRoomForm.controls["file_server_id"].setValue(
      this.editclassroom["content"].file_server_id
    );
    this.ClassRoomForm.reset();
    this.ClassRoomForm.get("id").setValue(this.editclassroom["content"].id);
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getClassRoom();
  }
}
